import {
  useTokenStore,
  tokenStoreLoadingPromise,
  useTokenStoreLoaded,
} from '@/src/common/store/useTokenStore'
import { useEffect, useState } from 'react'
import { useGetUserInformation } from '@/src/common/hooks/useGetUserInformation'

export function useIsUserSignedIn() {
  const [loading, setLoading] = useState(() => !useTokenStoreLoaded.getState().loaded)
  const { hasTokens } = useTokenStore()

  useEffect(() => {
    async function setLoadingOnceTokenStoreIsFinishedLoading() {
      await tokenStoreLoadingPromise
      setLoading(false)
    }

    void setLoadingOnceTokenStoreIsFinishedLoading()
  }, [])

  /** @deprecated you probably want to be using {@link isSignedInWithPhoneNumber} instead because if a user is "logged in" only because they've validated their email and have a token cached in the client, it doesn't necessarily mean they've already created the rest of the their account e.g. providing their first/last name + verifying their phone #. without the latter, the user should not be allowed to see anything past the account creation form */
  const isSignedIn = !loading && hasTokens()

  const { user } = useGetUserInformation()

  const isSignedInWithPhoneNumber =
    user?.phoneNumber &&
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    isSignedIn

  return {
    loading,
    isSignedInWithPhoneNumber,
    /** @deprecated @see @inheritdoc {@link isSignedIn} */
    isSignedIn,
  } as const
}
